export const getPopulatedPlayer = (player, populate_players) => {
  return player.user === populate_players[0]._id ? populate_players[0] : populate_players[1];
};
